import img1 from '../../static/img/class_types_page/MTH_Low_Impact_Dance_Fitness_1.webp';
import img2 from '../../static/img/class_types_page/MTH_Low_Impact_Dance_Fitness_2.webp';
import quoteImg from '../../static/img/class_types_page/MTH_Low_Impact_Dance_Fitness_3.webp';

const Class = {
  code: 'm2h',
  name: 'The Moving to Heal Class',
  sentence1: 'Moving to Heal supports people looking for a gentle approach to Nia® and for those dealing with a wide range of therapeutic issues issues from injury, trauma, grief, short-term to long-term illness.',
  sentence2: 'Learn to slow down and personalize movement to fit your body\'s way while focusing on the sensation of feeling better move by move, breath by breath. Improve feelings of wellness regardless of physical condition.',
  quoteSentence1: 'Nia is FUN! There are so many ways to  adapt it to a wide range of people. I’ve been living with MS for 20 years and now do chair Nia but I still have fun.',
  quoteAttr: 'Miriam H., Nia Student',
  img1,
  img2,
  quoteImg,
  img1Alt: 'A silhouette of a person with their arms outstretched outside during sunset, illustrating the somatic focus of Nia\'s low impact dance fitness classes',
  img2Alt: 'A group of people with their hands outstretched during a Nia low impact dance fitness class',
  quoteAlt: 'A quote that says "The art of feeling better" in blue script writing, illustrating how meaningful and important Nia\'s low impact dance fitness classes are',
};

export default Class;
